import { Component, OnInit, Input, Output, EventEmitter, OnChanges } from '@angular/core';

import { ContactSearchService } from '../../../services/contacts/contact-search.service';
import { FormFieldComponent } from '../../abstract/form-field/form-field.component';

@Component({
  selector: 'app-contact-search',
  templateUrl: './contact-search.component.html',
  styleUrls: ['./contact-search.component.css'],
})
export class ContactSearchComponent extends FormFieldComponent {
  /**
   * Contact search term
   * @type {string}
   */
  contactSearchTerm: string;

  /**
   * Indicates if include search result item in output
   */
  @Input() include_item: boolean = false;

  /**
   * Contact id for initial selection
   */
  @Input() contactId: number | undefined | null;

  /**
   * Indicates if input size should be small based on bootstrap form-control class
   */
  @Input() small_input: boolean = false;

  /**
   * Indicates if search should be allowed
   */
  @Input() editable: boolean = true;

  /**
   * Additional params for autocomplete search
   */
  @Input() params: any = {};

  /**
   * Get placeholder from parent component and overrides the default in HTML
   */
  @Input() placeholder: string;

  /**
   * Output contact id on contact selection
   * @param {EventEmitter<number> = new EventEmitter(} ) contact_id variable name
   */
  @Output() contact_id: EventEmitter<number> = new EventEmitter();

  /**
   * Indicates if contact selection is only to be sent as output and not show in the HTML
   */
  @Input() select_only: boolean = false;

  /**
   * Output selected contact item from the search results
   * @param {EventEmitter<any>    = new EventEmitter(} ) contact variable name
   */
  @Output() contact: EventEmitter<any> = new EventEmitter();

  /**
   * Outputs if contact selection is to be cleared
   * @param {EventEmitter<any>    = new EventEmitter(} ) clearContact variable name
   */
  @Output() clearContact: EventEmitter<any> = new EventEmitter();

  /**
   * Constructor
   * @param {ContactSearchService} private contactSearchService Service to access contacts controller for search related actions
   */
  constructor(private contactSearchService: ContactSearchService) {
    super();
    this.inline = false;
  }

  // Component lifecycle events

  /**
   * Called on component initialization
   */
  ngOnInit() {
    super.ngOnInit();
  }

  /**
   * Called on changes to component variables
   * @param {any} changes Angular object with variables which have changed
   */
  ngOnChanges(changes: any) {
    if (changes.contactId && changes.contactId.currentValue && !this.select_only)
      this.contactSearchService.getContactInfo(this.contactId!).then((response_json) => {
        this.contactSearchTerm = response_json.name;
      });
    else if (this.select_only) this.contactSearchTerm = '';
    super.ngOnChanges(changes);
  }

  // Component methods

  /**
   * Called to clear selected contact and output to parent component
   */
  clearSelectedContact(): void {
    this.contactId = undefined;
    this.contactSearchTerm = '';
    this.clearContact.emit('clearContact');
  }

  /**
   * Called when contact search result item is selected
   * @param {any} item Search result item as per AutoComplete format of label and value fields
   */
  contactSearchOnSelect(item: any): void {
    if (this.include_item) this.contactId = item.id;
    else this.contactId = item;
    if (this.select_only) {
      let scope = this;
      this.contact.emit(item);
      window.setTimeout(function () {
        scope.contactSearchTerm = '';
      }, 100);
    } else if (this.include_item) {
      this.contact.emit(item);
      this.contact_id.emit(Number(item.id));
    } else this.contact_id.emit(Number(item));
  }
}
